import ThirdLogin from "./thirdLogin";
import IdaasHome from "./home";

export {
    ThirdLogin,
    IdaasHome
}
